import { MutationTree } from 'vuex'
import * as types from './mutation-types'
import AddressesState from '../../types/Address/AddressesState'

const mutations: MutationTree<AddressesState> = {
  [types.USER_ADDRESS_ADD] (state, address) {
    state.addresses.push(address)
  },
  [types.GUEST_ADDRESS_ADD] (state, address) {
    state.guest_addresses.push(address)
  },
  [types.USER_ADDRESS_SET] (state, address) {
    state.selectedAddress = address;
  },
  [types.USER_ADDRESS_SET_LIST] (state, addresses) {
    state.addresses = addresses
  },
  [types.GUEST_ADDRESS_SET_LIST] (state, addresses) {
    state.guest_addresses = addresses
  },
  [types.GUEST_ADDRESS_SET_DEFAULT] (state, addressId) {
    const newDefaultAddress = state.guest_addresses.find(address => address.id === addressId);
    state.guest_addresses = [
      {
        ...newDefaultAddress,
        default_shipping: true
      },
      ...state.guest_addresses.filter(address => address.id !== addressId).map(address => ({
        ...address,
        default_shipping: false
      }))
    ]
  },
  [types.GUEST_ADDRESS_UPDATE] (state, address) {
    let idx = state.addresses.findIndex(a => a.id === address.id)
    state.guest_addresses.splice(idx, 1, address)
  },
  [types.USER_ADDRESS_UPDATE] (state, address) {
    let idx = state.addresses.findIndex(a => a.id === address.id)
    state.addresses.splice(idx, 1, address)
  },
  [types.USER_ADDRESS_DELETE] (state, {address_id}) {
    state.addresses = state.addresses.filter(address => address.id !== address_id);
  },
  [types.USER_ADDRESS_SET_LIST_LOADER] (state, loaded) {
    state.addressesLoading = loaded;
  },
  [types.GUEST_ADDRESS_DELETE] (state, addressList) {
    state.guest_addresses = addressList;
    state.selectedAddress = null;
  },
  [types.GUEST_ADDRESS_CLEAR_STATE] (state) {
    state.selectedAddress = null;
    state.guest_addresses = [];
  },
  [types.USER_ADDRESS_CLEAR_STATE_AFTER_LOGOUT] (state) {
    state.selectedAddress = null;
    state.addresses = [];
    state.guest_addresses = [];
    state.addressesLoading = false;
  }
}

export default mutations
